import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface DropdownMenuProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  width?: number | string;
  className?: string;
}
export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  trigger,
  children,
  position = 'bottom',
  width = 'auto',
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const closeDropdown = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        closeDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const getPositionStyles = () => {
    switch (position) {
      case 'top':
        return 'bottom-full mb-1';
      case 'bottom':
        return 'top-full mt-1';
      case 'left':
        return 'right-full mr-1';
      case 'right':
        return 'left-full ml-1';
      default:
        return 'top-full mt-1';
    }
  };
  return <div className={`relative inline-block ${className}`} ref={dropdownRef} data-id="element-91">
      <div onClick={toggleDropdown} className="cursor-pointer" data-id="element-92">
        {trigger}
      </div>
      {isOpen && <div className={`absolute z-50 ${getPositionStyles()} bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md shadow-lg`} style={{
      width: width
    }} data-id="element-93">
          {children}
        </div>}
    </div>;
};
export const DropdownItem: React.FC<{
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}> = ({
  onClick,
  children,
  className = ''
}) => {
  return <div className={`px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer ${className}`} onClick={e => {
    e.stopPropagation();
    if (onClick) onClick();
  }} data-id="element-94">
      {children}
    </div>;
};
export default DropdownMenu;